module.exports = __webpack_public_path__ + "public/adminIcons/export.png?12472769";